import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=e8df2e0e&scoped=true&"
import script from "./AdminTasks.vue?vue&type=script&lang=js&"
export * from "./AdminTasks.vue?vue&type=script&lang=js&"
import style0 from "./AdminTasks.vue?vue&type=style&index=0&id=e8df2e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8df2e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8df2e0e')) {
      api.createRecord('e8df2e0e', component.options)
    } else {
      api.reload('e8df2e0e', component.options)
    }
    module.hot.accept("./AdminTasks.vue?vue&type=template&id=e8df2e0e&scoped=true&", function () {
      api.rerender('e8df2e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminTasks.vue"
export default component.exports